module.exports = __webpack_public_path__ + "static/media/ar21_jmengucci.28c720ce.jpeg";